module.exports = __webpack_public_path__ + "../resources/img/ic_guide_tooltip.1dc080cc.svg";